module.exports = __webpack_public_path__ + "img/undraw_hologram.09caad0a.svg";